'use strict';

var DrawdownTable = function(options) {
	this.options = options;
};

DrawdownTable.prototype.getName = function(id) {
	if(this.validId(id)) {
		return this.options[id].name;	
	}
};

DrawdownTable.prototype.getPaymentsInYear = function(id) {
	if(this.validId(id)) {
		return this.options[id].paymentsInYear;
	}
};

DrawdownTable.prototype.getPaymentPeriod = function(id) {
	if(this.validId(id)) {
		return this.options[id].paymentPeriod;
	}
};

DrawdownTable.prototype.validId = function(id) {
	if(typeof this.options[id] != 'object') {
		throw Error('DC-Engine: Invalid drawdown frequency id: '+ id);
	}

	return true;
};

//Node module export
if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
        exports = module.exports = DrawdownTable;
    }
    exports.DrawdownTable = DrawdownTable;
}